import React from "react";
import Helmet from "react-helmet";
import { Link } from "react-router-dom";
import Icon from "../components/Icon";

export default function Page404() {
    return (
        <>
            <Helmet>
                <title>404 - Pagina niet gevonden - Werken bij Smith</title>
                <meta name="robots" content="noindex" />
            </Helmet>
            <section className="job-header not-found-header">
                <div className="site-container">
                    <span className="eyebrow">404 · PAGINA NIET GEVONDEN</span>
                    <h1>Even de weg kwijt?</h1>
                    <p>
                        Deze pagina bestaat niet meer. Misschien staat jouw
                        volgende stap wel tussen onze vacatures.
                    </p>
                    <Link to="/#vacatures" className="button button-orange">
                        Bekijk de vacatures <Icon />
                    </Link>
                </div>
            </section>
        </>
    );
}
